import { render } from "./MaterialCheckbox.vue?vue&type=template&id=5d22d1a4&scoped=true"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js"

import "./MaterialCheckbox.vue?vue&type=style&index=0&id=5d22d1a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d22d1a4"]])

export default __exports__